import tableAudit from './tableAudit';
export default {
  title: 'Audit',
  attributeName: "audit",
  getURL: 'audit',
  createURL: 'audit',
  removeURL: 'audit',
  sessionParams: [],
  noArea: true,
  tableConfig: tableAudit,
  autoUpdate: false,
};
